// Dies ist der Haupteinstiegspunkt der Vue-Anwendung.

import { createApp } from 'vue'
import App from './App.vue'
import router from './router' // Importiere den Router

// Importiert die globalen SCSS-Stile, die in der gesamten Anwendung gelten sollen.
import './styles/main.scss' // Importiere die globalen SCSS-Stile
import {start} from './services/global'


// Erstellt die Vue-App-Instanz, bindet den Router ein und hängt die App
// an das DOM-Element mit der ID '#app' in der public/index.html an.
createApp(App).use(router).mount('#app') // Verwende den Router in der App

// Startet globale Dienste oder Initialisierungslogik.
start();